"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var Typography_1 = require("../Typography/Typography");
var ListItem_style_1 = __importDefault(require("./ListItem.style"));
/**
 * ListItem atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-listitem--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/ListItem Source}
 */
var ListItem = function (_a) {
    var _b = _a.entry, primaryText = _b.primaryText, secondaryText = _b.secondaryText, className = _a.className, _c = _a.noIcon, noIcon = _c === void 0 ? false : _c;
    var classes = (0, ListItem_style_1.default)();
    return ((0, jsx_runtime_1.jsxs)(core_1.ListItem, __assign({ className: className, alignItems: 'flex-start', disableGutters: true }, { children: [renderItemIcon(), renderItemText()] })));
    function renderItemIcon() {
        if (noIcon) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(core_1.ListItemIcon, __assign({ className: classes.listIconSize }, { children: (0, jsx_runtime_1.jsx)(core_1.SvgIcon, __assign({ color: 'secondary', viewBox: '0 0 4 4', fontSize: 'inherit' }, { children: (0, jsx_runtime_1.jsx)("circle", { r: '1', cx: '2', cy: '2' }) })) })));
    }
    function renderItemText() {
        return ((0, jsx_runtime_1.jsx)(core_1.ListItemText, { disableTypography: true, primary: typeof primaryText === 'string' ? ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: classes.primarySpacing }, { children: primaryText }))) : (primaryText), secondary: typeof secondaryText === 'string' ? ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ breakWord: true, variant: 'headline3' }, { children: secondaryText }))) : (secondaryText) }));
    }
};
exports.ListItem = ListItem;
